import { apiFetch } from "../../lib/api";
import type { DashboardAnalyticsData } from "./DashboardPage.types";

export async function fetchDashboardAnalytics(after: string): Promise<DashboardAnalyticsData> {
  const response = await apiFetch(`/dashboard?after=${encodeURIComponent(after)}`);
  if (!response.ok) {
    const data = await response.json().catch(() => ({ error: "Impossible de charger les analytics PostHog." }));
    throw new Error(data.error || "Impossible de charger les analytics PostHog.");
  }

  return response.json();
}